import { useEffect, useState } from "react";

/**
 * ScrollProgress — slim lime indicator at the very top of the page.
 * Pure DOM update via rAF — no React re-renders during scroll.
 */
export function ScrollProgress() {
  const [pct, setPct] = useState(0);

  useEffect(() => {
    let rafId = null;
    const update = () => {
      const h = document.documentElement;
      const scrolled = h.scrollTop || document.body.scrollTop;
      const total = (h.scrollHeight - h.clientHeight) || 1;
      const p = (scrolled / total) * 100;
      setPct(Math.max(0, Math.min(100, p)));
      rafId = null;
    };
    const onScroll = () => {
      if (rafId) return;
      rafId = requestAnimationFrame(update);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    update();
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <div className="lp-scroll-progress" aria-hidden="true">
      <div
        className="lp-scroll-progress-bar"
        style={{ transform: `scaleX(${pct / 100})` }}
      />
    </div>
  );
}
